import type { InterventionLite } from "@/entities/intervention";
import type { Int } from "@/types";

import { useInterventionsBatchUpdate } from "@/entities/interventions";
import { useBatchEditForm } from "@/modules/batch-edit-form";

const fieldName = "intervention_template_id";

export const useInterventionsBatchEditTemplate = (
  interventions: InterventionLite[]
) => {
  const initialValue = interventions[0]?.[fieldName];

  const { mutate, isPending, status, error } =
    useInterventionsBatchUpdate(interventions);

  const onMutateReady = (value: Int | null) => {
    mutate({ [fieldName]: value });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
